<div class="hold-transition sidebar-mini layout-navbar-fixed layout-footer-fixed">
    <!-- Site wrapper -->
    <div class="wrapper">
        <!-- Navbar -->
        <app-header></app-header>
        <!-- /.navbar -->

        <!-- Main Sidebar Container -->
        <app-sidebar [page]="'settings'" [subPage]="'right'"></app-sidebar>

        <!-- Content Wrapper. Contains page content -->
        <div class="content-wrapper">
            <!-- Content Header (Page header) -->
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h1 class="m-0">Settings</h1>
                        </div><!-- /.col -->
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="#">Home</a></li>
                                <li class="breadcrumb-item"><a href="#">Settings</a></li>
                                <li class="breadcrumb-item active">Administrator Rights</li>
                            </ol>
                        </div><!-- /.col -->
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->

            <!-- Main content -->
            <section class="content">
                <div class="container-fluid">
                    <app-module-menu [module]="'settings'" [activeSlug]="'right'"></app-module-menu>
                    <div class="row">
                        <div class="modal fade" id="modal-admin-right-form" tabindex="-1" role="dialog" aria-hidden="true" *ngIf="checkService.canWrite('administrators.right') || checkService.canModify('administrators.right')">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                <div class="card card-primary card-outline mb-0">
                                    <div class="card-header">
                                        <h4 class="card-title">{{formHeader}}</h4>
                                        <div class="card-tools">
                                            <button type="button" class="btn btn-tool" data-dismiss="modal" (click)="cancelEdit()"><i class="fas fa-times"></i></button>
                                        </div>
                                    </div>
                                    <!-- form start -->
                                    <form [formGroup]="dataForm">
                                        <div class="card-body">
                                            <div class="form-group">
                                                <label for="title">Title</label>
                                                <input type="text" required
                                                    [ngClass]="(title.invalid && (title.dirty || title.touched)) ? 'form-control is-invalid' : (title.valid)? 'form-control is-valid':'form-control'"
                                                    formControlName="title" id="title" placeholder="Category Title">
                                                <div *ngIf="title.invalid && (title.dirty || title.touched)"
                                                    class="invalid-feedback">
                                                    <div *ngIf="title.errors.required">Title is required</div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label for="super">Super Admin with Overrides</label><br>
                                                <input type="checkbox" checked class="orm-control"
                                                    formControlName="super" id="super">
                                            </div>
                                            <div class="form-group">
                                                <label for="read">Read</label><br>
                                                <input type="checkbox" checked class="orm-control"
                                                    formControlName="read" id="read">
                                            </div>
                                            <div class="form-group">
                                                <label for="write">Write</label><br>
                                                <input type="checkbox" class="orm-control" formControlName="write"
                                                    id="write">
                                            </div>
                                            <div class="form-group">
                                                <label for="modify">Modify</label><br>
                                                <input type="checkbox" class="orm-control" formControlName="modify"
                                                    id="modify">
                                            </div>

                                            <div class="form-group">
                                                <label for="mainPage">Main Page</label>
                                                <select required
                                                    [ngClass]="(mainPage.invalid && (mainPage.dirty || mainPage.touched)) ? 'form-control is-invalid' : (mainPage.valid)? 'form-control is-valid':'form-control'"
                                                    formControlName="mainPage" id="mainPage">
                                                    <option value="">Select One</option>
                                                    <option value="home">Home</option>
                                                    <option *ngFor="let page of allowedPage;" value="{{page}}">{{page}}
                                                    </option>
                                                </select>
                                                <div *ngIf="mainPage.invalid && (mainPage.dirty || mainPage.touched)"
                                                    class="invalid-feedback">
                                                    <div *ngIf="mainPage.errors.required">Main Page is required</div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label for="currency">Allowed Pages</label>
                                                <select required
                                                    [ngClass]="(pages.invalid && (pages.dirty || pages.touched)) ? 'form-control is-invalid' : (pages.valid)? 'form-control is-valid':'form-control'"
                                                    formControlName="pages" id="pages" multiple>
                                                    <option *ngFor="let page of allowedPage;" value="{{page}}">{{page}}
                                                    </option>
                                                </select>
                                                <div *ngIf="pages.invalid && (pages.dirty || pages.touched)"
                                                    class="invalid-feedback">
                                                    <div *ngIf="pages.errors.required">Minimum of 1 selection</div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label for="currency">Country</label>
                                                <select required
                                                    [ngClass]="(country.invalid && (country.dirty || country.touched)) ? 'form-control is-invalid' : (country.valid)? 'form-control is-valid':'form-control'"
                                                    formControlName="country" id="country" multiple>
                                                    <option *ngFor="let countryRows of countryList;"
                                                        value="{{countryRows.iso}}">{{countryRows.title}}</option>
                                                </select>
                                                <div *ngIf="country.invalid && (country.dirty || country.touched)"
                                                    class="invalid-feedback">
                                                    <div *ngIf="country.errors.required">Prefered Market is required
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- /.card-body -->

                                        <div class="card-footer">
                                            <button type="button"
                                                [disabled]="!dataForm.valid || dataForm.pending || processing"
                                                (click)="onCreate()"
                                                class="btn btn-primary">{{buttonText}}</button>&nbsp;
                                            <button type="button" *ngIf="editingRight" [disabled]="processing"
                                                data-dismiss="modal" (click)="cancelEdit()"
                                                class="btn btn-default">Cancel</button>
                                            <button type="button" *ngIf="!editingRight" data-dismiss="modal" (click)="cancelEdit()" class="btn btn-default">Cancel</button>
                                        </div>
                                    </form>
                                    <!-- /.card-body -->
                                </div>
                            </div>
                        </div>
                        </div>
                        <!-- /.col -->
                        <div class="col-md-12">
                            <div class="card card-primary card-outline">
                                <img [hidden]='!loading' [class]="loading?'mx-auto d-block':''"
                                    src="assets/LoadingGIF/Rolling-1s-75px.gif">

                                <!-- Default box -->
                                <div class="card card-solid" [hidden]='loading'>
                                    <div class="card-header">
                                        <h3 class="card-title">
                                            <i class="fas fa-edit"></i>
                                            {{mainHeader}}
                                        </h3>
                                        <div class="text-right">
                                            <div class="btn-group">
                                                <button type="button" class="btn btn-primary btn-sm" *ngIf="checkService.canWrite('administrators.right')" data-toggle="modal" data-target="#modal-admin-right-form" (click)="cancelEdit()">
                                                    <i class="fas fa-plus"></i> Add Role
                                                </button>
                                                <a [routerLink]="['/settings/countries']" class="btn btn-default btn-sm"
                                                    type="button">All</a>
                                                <a [routerLink]="['/settings/countries/active']"
                                                    class="btn btn-default btn-sm" type="button">Active</a>
                                                <a [routerLink]="['/settings/countries/inactive']"
                                                    class="btn btn-default btn-sm" type="button">In-Active</a>

                                                <div class="input-group-sm">
                                                    <input type="text" class="form-control" placeholder="Search roles">
                                                </div>
                                                <button [routerLink]="['/adverts/Deleted']"
                                                    class="btn btn-primary btn-sm" type="button"><i
                                                        class="fas fa-search"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body table-responsive p-0">
                                        <table class="table table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Title</th>
                                                    <th>Super</th>
                                                    <th>Read</th>
                                                    <th>Write</th>
                                                    <th>Modify</th>
                                                    <th>Main Page</th>
                                                    <th>Allowed Pages</th>
                                                    <th>Countries</th>
                                                    <th>Status</th>
                                                    <th>Created By</th>
                                                    <th>Created</th>
                                                    <th>Last Modified By</th>
                                                    <th>Last Modified</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let adminRightRow of adminRightList;">
                                                    <td>{{adminRightRow.adminType}}</td>
                                                    <td>
                                                        <span *ngIf='adminRightRow.super'><i style="color: #080;"
                                                                class="fas fa-check-square"></i></span>
                                                        <span *ngIf='!adminRightRow.super'><i style="color: #900;"
                                                                class="fas fa-window-close"></i></span>
                                                    </td>
                                                    <td>
                                                        <span *ngIf='adminRightRow.read'><i style="color: #080;"
                                                                class="fas fa-check-square"></i></span>
                                                        <span *ngIf='!adminRightRow.read'><i style="color: #900;"
                                                                class="fas fa-window-close"></i></span>
                                                    </td>
                                                    <td>
                                                        <span *ngIf='adminRightRow.write'><i style="color: #080;"
                                                                class="fas fa-check-square"></i></span>
                                                        <span *ngIf='!adminRightRow.write'><i style="color: #900;"
                                                                class="fas fa-window-close"></i></span>
                                                    </td>
                                                    <td>
                                                        <span *ngIf='adminRightRow.modify'><i style="color: #080;"
                                                                class="fas fa-check-square"></i></span>
                                                        <span *ngIf='!adminRightRow.modify'><i style="color: #900;"
                                                                class="fas fa-window-close"></i></span>
                                                    </td>
                                                    <td>{{adminRightRow.mainPage}}</td>
                                                    <td>
                                                        <span *ngFor="let pages of adminRightRow.pages;">
                                                            <span class="badge bg-primary">{{pages}}</span>&nbsp;
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span *ngFor="let countryList of adminRightRow.countryList;">
                                                            <span
                                                                class="badge bg-primary">{{countryList.name}}</span>&nbsp;
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span *ngIf="isRightActive(adminRightRow)"
                                                            class="badge bg-success">Active</span>
                                                        <span *ngIf="!isRightActive(adminRightRow)"
                                                            class="badge bg-warning">Inactive</span>
                                                    </td>
                                                    <td>{{adminRightRow.createdBy.username}}</td>
                                                    <td>{{adminRightRow.created}}</td>
                                                    <td>{{adminRightRow.lastModifiedBy.username}}</td>
                                                    <td>{{adminRightRow.lastModified}}</td>
                                                    <td>
                                                        <div class="btn-group btn-group-sm">
                                                            <button type="button" class="btn btn-info" *ngIf="checkService.canModify('administrators.right')"
                                                                title="Modify"
                                                                data-toggle="modal" data-target="#modal-admin-right-form"
                                                                (click)="editRight(adminRightRow)">
                                                                <i class="fas fa-edit"></i>
                                                            </button>
                                                            <button *ngIf="isRightActive(adminRightRow) && checkService.canModify('administrators.right')" type="button"
                                                                class="btn btn-warning" title="Disable"
                                                                (click)="changeRightStatus(adminRightRow, 'inactive')">
                                                                <i class="fas fa-ban"></i>
                                                            </button>
                                                            <button *ngIf="!isRightActive(adminRightRow) && checkService.canModify('administrators.right')" type="button"
                                                                class="btn btn-success" title="Enable"
                                                                (click)="changeRightStatus(adminRightRow, 'active')">
                                                                <i class="fas fa-check"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-danger" *ngIf="checkService.canModify('administrators.right')"
                                                                title="Delete"
                                                                (click)="deleteRight(adminRightRow)">
                                                                <i class="fas fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr *ngIf="adminRightList.length == 0">
                                                    <td colspan="14" class="text-center">No record to show</td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <th>Title</th>
                                                    <th>Super</th>
                                                    <th>Read</th>
                                                    <th>Write</th>
                                                    <th>Modify</th>
                                                    <th>Main Page</th>
                                                    <th>Allowed Pages</th>
                                                    <th>Countries</th>
                                                    <th>Status</th>
                                                    <th>Created By</th>
                                                    <th>Created</th>
                                                    <th>Last Modified By</th>
                                                    <th>Last Modified</th>
                                                    <th>Action</th>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                    <!-- /.card-body -->
                                </div>
                            </div>
                            <!-- /.card -->
                        </div>
                        <!-- /.col -->
                    </div>
                    <!-- /.row -->
                </div><!-- /.container-fluid -->
            </section>
            <!-- /.content -->
            <!-- /.content-wrapper -->

        </div>
        <!-- /.content-wrapper -->
        <app-footer></app-footer>
    </div>
    <!-- ./wrapper -->
</div>
